import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Warning from '@material-ui/icons/Warning';

import THEME from '../../../../../constants/theme';

export const ButtonConfirmed = styled(Button)`
  border-radius: 8px !important;
  color: ${THEME.primary} !important;
  font-family: Montserrat !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  line-height: 1.14 !important;
  letter-spacing: 1.5px !important;
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin-top: 20px;
  max-width: 872px;
  width: 100%;
  gap: 16px;
`;

export const OrderStatus = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
`;

export const IconAlert = styled(Warning)`
  color: ${THEME.warning};
  margin-left: 3px;
`;

export const Text = styled.p`
  color: ${THEME.warning};
  flex: 1;
  font-family: Montserrat;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  margin-left: 8px;
`;
